// Main product slider
const pdpSlider = new Swiper('.pdp-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20
});

window.pdpSlider = pdpSlider;

// Sync slider with thumbnails
pdpSlider.on('slideChange', slider => {
  let idx = slider.realIndex;
  const activeThumb = document.querySelector('.pdp-thumbnail.active');
  const newThumb = document.querySelector(`.pdp-thumbnail[data-index="${idx}"]`);
  
  activeThumb.classList.remove('active');
  newThumb.classList.add('active');
});

// Sync thumbnails with slider
const thumbnailContainer = document.querySelector('.pdp-thumbnails');
thumbnailContainer.addEventListener('click', event => {
  const button = event.target.closest('.pdp-thumbnail');
  if (button) {
    let idx = Number(button.dataset.index);
    pdpSlider.slideToLoop(idx);
  }
});

// Supplement facts
const supplementFacts = document.querySelector('.supplement-facts');
const openSupplementFactsButtons = document.querySelectorAll('.supplement-facts-open');
const closeSupplementFactsButtons = document.querySelectorAll('.supplement-facts-close');

openSupplementFactsButtons.forEach(button => {
  button.addEventListener('click', event => {
    event.preventDefault();
    supplementFacts.classList.remove('invisible', 'opacity-0');
  });
});

closeSupplementFactsButtons.forEach(button => {
  button.addEventListener('click', event => {
    event.preventDefault();
    supplementFacts.classList.add('invisible', 'opacity-0');
  });
});

// Read more description
const readMore = document.querySelector('.read-more');
if (readMore) {
  readMore.addEventListener('click', event => {
    document.querySelector('.short-description').classList.add('hidden');
    document.querySelector('.full-description').classList.remove('hidden');
  });
}

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    // const submitButton = this.querySelector('[type="submit"]');

    // submitButton.setAttribute('disabled', true);
    // submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
    });
    
    var _this = this;
    let addToCartForm = this.form;
    let formData = new FormData(addToCartForm);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      return response.json();
    })
    .then(parsedState => {
      this.cartDrawer.rerender(false);
      if( typeof parsedState.properties._product_discount !== "undefined" && sessionStorage.getItem("discountValue")){
        fetch('/checkout?discount=' + parsedState.properties._product_discount)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
          }
          return response.text();
        })
        .then(data => {
          // Handle the data from the response
          this.cartDrawer.rerender(false);
        })
        .catch(error => {
          // Handle errors that occurred during the fetch
          console.error('Fetch error:', error);
        });
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      // submitButton.classList.remove('loading');
      // submitButton.removeAttribute('disabled');
      this.cartDrawer.rerender(false);
      this.cartDrawer.open();
    });

    // fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    //   .then((response) => response.json())
    //   .then((parsedState) => {
    //     this.getSectionsToRender().forEach((section => {
    //       const elementToReplace =
    //         document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    //       console.log(elementToReplace, parsedState)
    //       elementToReplace.innerHTML =
    //         this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    //     }));
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   })
    //   .finally(() => {
    //     // submitButton.classList.remove('loading');
    //     // submitButton.removeAttribute('disabled');
    //     this.cartDrawer.open();
    //   });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: 'cart-drawer',
        selector: '#cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '#cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
});